// extracted by mini-css-extract-plugin
export default {"agent-container":"styles_agent-container__U7Im4","header":"styles_header__EPLhT","loader":"styles_loader__W+jgE"};